import axios from '@/axios/api.request'

export const save = (form) => axios.request({
    url: '/mediator/apply/save',
    data: form,
    method: 'post'
  })

  export const back = (form) => axios.request({
    url: '/mediator/apply/back',
    data: form,
    method: 'post'
  })